import { useFeatureFlagsStore } from '@/stores/feature-flags'

/**
 * Check if the leaderboard feature is enabled
 */
export function isLeaderboardEnabled(): boolean {
  return useFeatureFlagsStore().isFeatureEnabled('leaderboard')
}

export function isCheckoutPageEnabled(): boolean {
  return useFeatureFlagsStore().isFeatureEnabled('checkout_page')
}

export function isDepositPageEnabled(): boolean {
  return useFeatureFlagsStore().isFeatureEnabled('deposit_page')
}
